export enum SchoolHeaders {
  name = 'School Name',
  districtName = 'District'
}

export enum SchoolProps {
  'Name' = 'Name'
}
